module.exports = __webpack_public_path__ + "img/1400f.5416a449.png";